"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterDefined = void 0;
const filterDefined = (obj) => Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value !== 'undefined') {
        acc[key] = value;
    }
    return acc;
}, {});
exports.filterDefined = filterDefined;
//# sourceMappingURL=filterDefined.js.map